import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Measurement } from '@usimweb/core/models';
import { PlotLayout } from '@usimweb/core/services';

import { PlotlyService } from 'angular-plotly.js';

@Component({
    selector: 'app-measurement-plot',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './measurement-plot.component.html',
    styleUrls: ['./measurement-plot.component.scss'],
    standalone: false
})
export class MeasurementPlotComponent extends PlotLayout implements OnInit {
  public override densityViscoChart: any[] = [];

  @Input() data: Measurement[] = [];

  @Input() override materialName: string = '';

  @Input() project: string = '';

  @Input() isLog: boolean = false;

  constructor(public override snackBar: MatSnackBar, public override plotlyService: PlotlyService) {
    super(plotlyService, snackBar);
  }

  ngOnInit(): void {
    if (this.isLog) {
      this.onInitViscoLayout();
    } else {
      this.onInitDensityLayout();
    }

    this.addCurves(this.data);
    let width = screen.width * 0.4;
    if (screen.width < 1200) {
      width = screen.width * 0.9;
    }
    this.densityViscoLayout.width = width;
    this.densityViscoLayout.height = 400;
    setTimeout(() => {
      this.densityViscoLayout.title = this.project + ': ' + this.materialName;
    }, 2000);
  }
}
